import type { AgentState } from '../../types/api';
import AgentCard from './AgentCard';

interface AgentDashboardProps {
  agents: AgentState[];
  stage: 'discovery' | 'results';
}

export default function AgentDashboard({ agents, stage }: AgentDashboardProps) {
  const completedCount = agents.filter(
    (a) => a.status === 'found' || a.status === 'analyzed',
  ).length;
  const totalCount = agents.length;
  const allComplete = completedCount === totalCount;

  return (
    <div className="space-y-8">
      {/* Header */}
      <div className="flex items-center gap-3">
        {!allComplete ? (
          <>
            <span className="relative flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-ti-cyan opacity-75" />
              <span className="relative inline-flex rounded-full h-3 w-3 bg-ti-cyan" />
            </span>
            <h2 className="text-xl font-bold text-ti-text">
              Discovery in Progress
            </h2>
          </>
        ) : (
          <>
            <span className="relative flex h-3 w-3">
              <span className="relative inline-flex rounded-full h-3 w-3 bg-ti-green" />
            </span>
            <h2 className="text-xl font-bold text-ti-text">
              Discovery Complete
            </h2>
          </>
        )}
      </div>

      {/* Agent grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {agents.map((agent) => (
          <AgentCard key={agent.id} agent={agent} />
        ))}
      </div>

      {/* Progress bar */}
      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-ti-text-muted">
            Agent Progress
          </span>
          <span className="font-mono text-ti-text-dim">
            {completedCount}/{totalCount}
          </span>
        </div>
        <div className="h-1.5 bg-ti-border rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-700 ease-out"
            style={{
              width: `${(completedCount / totalCount) * 100}%`,
              backgroundColor: allComplete
                ? 'var(--color-ti-green)'
                : 'var(--color-ti-cyan)',
            }}
          />
        </div>
      </div>
    </div>
  );
}
